import { render, staticRenderFns } from "./TablaEmpleados.vue?vue&type=template&id=6bf3785a&scoped=true"
import script from "./TablaEmpleados.vue?vue&type=script&lang=js"
export * from "./TablaEmpleados.vue?vue&type=script&lang=js"
import style0 from "./TablaEmpleados.vue?vue&type=style&index=0&id=6bf3785a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_css-loader@6.11.0_webpack@5.107.2_postcss@8_ff446875d22e2f3af5a28e88f68f10a6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf3785a",
  null
  
)

export default component.exports